import { getRuntimeApiBase } from "../../lib/runtime-api-base";
import { WelcomeShell } from "./WelcomeShell";
import { WelcomeStepBody } from "./WelcomeStepBody";
import type { WelcomeOnboardingProps } from "./welcome-onboarding-types";
import { useWelcomeOnboardingController } from "./use-welcome-onboarding-controller";
import "./welcome-onboarding.css";

const DEFAULT_API_BASE = getRuntimeApiBase();

export function WelcomeOnboarding(props: WelcomeOnboardingProps) {
  const apiBase = props.apiBase ?? DEFAULT_API_BASE;
  const c = useWelcomeOnboardingController({ ...props, apiBase });
  return (
    <WelcomeShell
      isDeskReady={props.isDeskReady}
      message={c.message}
      step={c.step}
      surface={c.surface}
      userEmail={props.userEmail}
    >
      <WelcomeStepBody
        apiKey={c.apiKey}
        busy={c.busy}
        fileRef={c.fileRef}
        isBusy={c.isBusy}
        oauthCommand={c.oauthCommand}
        onApiKeyChange={c.setApiKey}
        onAvatar={c.actions.chooseAvatar}
        onConfirmGrok={c.actions.confirmManagedGrok}
        onCreateDesk={c.actions.createDesk}
        onJoinPic={c.actions.joinPricedInCapital}
        onPermissionContinue={c.actions.savePermissions}
        onPermissionRequest={c.actions.requestPermission}
        onPermissionSkip={c.actions.skipPermission}
        onProfileSubmit={c.actions.saveProfile}
        onProfileUpdate={c.actions.updateProfileField}
        onProviderChange={c.setProvider}
        onProviderSubmit={c.actions.submitProvider}
        permissionStatuses={c.permissionStatuses}
        profile={c.profile}
        provider={c.provider}
        step={c.step}
        surface={c.surface}
      />
    </WelcomeShell>
  );
}
